import React from 'react';
import { Backdrop, CircularProgress } from '@mui/material';

const LoadingPage = ({ isLoading }) => {
    return (
        <>
            <Backdrop
                sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
                open={isLoading}
            >
                <CircularProgress size={50} />
            </Backdrop>
        </>
    );
};
export { LoadingPage };
